import { FilterServiceType } from "./filter.service.type";
import { AppType, APP_TYPE } from "../app.type";
import { Inject, Injectable } from "@angular/core";
import { FilterPage } from "../filter-list/filter-list.state";
import { filter } from "jszip";

@Injectable()
export class FilterService implements FilterServiceType {
  constructor(@Inject(APP_TYPE) private app: AppType) {}

  isChecked(
    field: string,
    option: string,
    currentFilters: Partial<FilterPage>[]
  ) {
    const filters = currentFilters
      .filter((f: Partial<FilterPage>) => f.filterLabelField === field)
      .map((v) => v.values);

    if (filters.length === 0) {
      return false;
    }

    if (filters.findIndex((o: string) => o === option) !== -1) {
      return true;
    }
    return false;
  }

  isSelected(field: string, currentFilters: Partial<FilterPage>[]): boolean {
    if (
      currentFilters.findIndex(
        (filter: Partial<FilterPage>) => filter.filterLabelField === field
      ) !== -1
    ) {
      return true;
    }
    return false;
  }

  lastUpdatedOnIsSelected() {
    if (
      this.app.filterHeaderTable.filters.findIndex(
        (filter: Partial<FilterPage>) =>
          filter.filterLabelField === this.app.fieldId.manufacturer.to ||
          filter.filterLabelField ===
            this.app.fieldId.manufacturer.lastUpdatedOn
      ) !== -1
    ) {
      return true;
    }
    return false;
  }

  setFilterValues(currentFilters: Partial<FilterPage>[]) {
    const values: {} = {};

    // Get all the filters that should be applied to the current view
    const map = currentFilters.reduce(
      (entryMap, e) =>
        entryMap.set(e.filterLabelField, [
          ...(entryMap.get(e.filterLabelField) || []),
          e,
        ]),
      new Map()
    );

    // If there are any filters create query based on the type of the field
    Array.from(map.keys()).forEach(async (key: string) => {
      if (key != null) {
        const splitKey = key.split(".")[1];
        if (map.get(key).length === 1) {
          (values as any)[splitKey] = map.get(key)[0].values;
        } else {
          (values as any)[splitKey] = [
            ...map.get(key).map((v: Partial<FilterPage>) => v.values),
          ];
        }
      }
    });

    return values;
  }

}
